import { ReactNode } from 'react';
import { ThemeProvider } from 'styled-components';

import { homepageTheme } from '@/components/homepageRefresh/homepage/HomepageLayout/data/theme';

export default function HomepageThemeProvider({ children }: { children: ReactNode }) {
	return <ThemeProvider theme={homepageTheme}>{children}</ThemeProvider>;
}
